import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const StyledStack = styled(Stack)({
  padding: '50px',
  gap: '45px',
  '& .MuiFormControlLabel-root': {
    justifyContent: 'start !important',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '15px',
    '& .MuiTypography-root': {
      maxWidth: 'none'
    }
  }
});

export const StyledButtonStack = styled(Stack)({
  gap: '10px',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  '& .MuiButton-root': {
    minWidth: '155px'
  }
});

export const FullWidthStack = styled(Stack)({
  width: '100%',
  alignItems: 'center',
  gap: '20px'
});

export const Title = styled(Typography)({
  fontWeight: '500 !important',
  fontSize: '24px !important',
  lineHeight: 1
});

export const SubTitle = styled(Typography)({
  maxWidth: '85%',
  padding: '0px'
});



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/CreateCompilationDialog/styles.js